var map = {
	"./17-cn.webp": 1140,
	"./17.webp": 1141,
	"./27-cn.webp": 1142,
	"./27.webp": 1143,
	"./7-cn.webp": 1144,
	"./7.webp": 1145,
	"./angpao-bg-mobile.jpg": 1146,
	"./angpao-bg.jpg": 1147,
	"./angpao-cn.webp": 1148,
	"./angpao.webp": 1149,
	"./button.png": 1150,
	"./close-eye.png": 1151,
	"./coin-1.png": 1152,
	"./coin.png": 1153,
	"./ketupak-open.png": 1154,
	"./ketupak.png": 1155,
	"./ketupak_ribbon.png": 1156,
	"./rain-1.png": 1157,
	"./rain-2.png": 1158,
	"./rain-3.png": 1159,
	"./raya-bg-mobile.png": 1160,
	"./raya-bg.png": 1161,
	"./shine.png": 1162,
	"./star-1.png": 1163,
	"./star-2.png": 1164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 455;